import React, { useEffect, useState } from 'react';
import KYCUpload from './KYCUpload';
import KYCProgress from './KYCProgress';
import { apiClient, endpoints } from '../../api';

const VendorKYC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [vendor, setVendor] = useState(null);
  const [kycStatus, setKycStatus] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem('vendorData');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setVendor(parsed);
        if (parsed?.id) {
          fetchKyc(parsed.id);
        } else {
          setLoading(false);
        }
      } catch (e) {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, []);

  const fetchKyc = async (vendorId) => {
    setLoading(true);
    setError('');
    try {
      const { data } = await apiClient.get(endpoints.kycOverallStatus(vendorId));
      if (data?.success && data?.data?.vendor) {
        setKycStatus(data.data.vendor);
      }
    } catch (e) {
      setError('Failed to load KYC status');
    } finally {
      setLoading(false);
    }
  };

  const handleKYCComplete = () => {
    if (vendor?.id) fetchKyc(vendor.id);
  };

  const handleSkip = () => {
    if (vendor?.id) fetchKyc(vendor.id);
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;

  if (!vendor?.id) {
    return <div>Please login as vendor to manage KYC.</div>;
  }

  const status = kycStatus?.status || vendor?.status || 'PENDING';

  if (status === 'APPROVED') {
    return <KYCProgress vendorData={vendor} onComplete={() => {}} onEdit={() => {}} />;
  }

  if (status === 'SUBMITTED' || status === 'IN_REVIEW') {
    return <KYCProgress vendorData={vendor} onComplete={() => {}} onEdit={() => {}} />;
  }

  return (
    <KYCUpload 
      vendorId={vendor.id} 
      onKYCComplete={handleKYCComplete} 
      onSkip={handleSkip} 
    />
  );
};

export default VendorKYC;


